
// Core profile translations shared between language files
export const profileTranslations = {
  userProfile: 'User Profile',
  identity: 'Identity',
  contactInfo: 'Contact Info',
  security: 'Security',
  preferences: 'Preferences',
  support: 'Support',
  authRequired: 'Authentication Required',
  pleaseLoginToViewProfile: 'Please log in to view your profile.',
  profileUpdated: 'Profile Updated',
  profileSectionUpdated: 'Your {section} information was updated successfully.',
  updateError: 'Update Error',
  couldNotUpdateProfile: 'Could not update profile. Please try again.',
  errorLoadingProfile: 'Error Loading Profile',
  tryRefreshPage: 'Please try refreshing the page.',
  
  // Contact info translations
  email: 'Email Address',
  emailCannotBeChanged: 'Email address cannot be changed.',
  phone: 'Phone Number',
  optionalForSmsNotifications: 'Optional. Used for SMS notifications if enabled.',
  country: 'Country',
  selectCountry: 'Select a country',
  language: 'Language',
  selectLanguage: 'Select a language',
  saving: 'Saving',
  save: 'Save Changes',
  edit: 'Edit',
  cancel: 'Cancel',
  invalidPhoneNumber: 'Invalid Phone Number',
  pleaseEnterValidPhone: 'Please enter a valid phone number.',
  contactInfoUpdated: 'Contact information updated successfully.',
  couldNotUpdateContact: 'Could not update contact information. Please try again.',
  
  // Identity translations
  firstName: 'First Name',
  lastName: 'Last Name',
  biography: 'Biography',
  tellUsAboutYourself: 'Tell us about yourself...',
  socialLinks: 'Social Links',
  website: 'Website',
  profileCompletion: 'Profile Completion',
  name: 'Name',
  identityInfoUpdated: 'Identity information updated successfully.',
  couldNotUpdateIdentity: 'Could not update identity information. Please try again.',
  noSocialLinksAdded: 'No social links added yet.',
  
  // Validation messages
  validationError: 'Validation Error',
  pleaseFixErrorsAndTryAgain: 'Please fix the errors and try again.',
  firstNameTooLong: 'First name is too long (max 50 characters)',
  lastNameTooLong: 'Last name is too long (max 50 characters)',
  bioTooLong: 'Bio is too long (max 500 characters)',
  invalidTwitterHandle: 'Invalid Twitter handle or URL',
  invalidInstagramHandle: 'Invalid Instagram handle',
  invalidGithubHandle: 'Invalid GitHub handle',
  invalidLinkedinUrl: 'Invalid LinkedIn URL',
  invalidFacebookUrl: 'Invalid Facebook URL',
  invalidWebsiteUrl: 'Invalid website URL',
  
  // Avatar upload
  invalidFileType: 'Invalid File Type',
  onlyImageFilesAllowed: 'Only image files are allowed (JPG, PNG, WebP, GIF)',
  fileTooLarge: 'File Too Large',
  maxFileSizeExceeded: 'Maximum file size is 5MB',
  uploadError: 'Upload Error',
  couldNotUploadAvatar: 'Could not upload avatar. Please try again.',
  previewError: 'Preview Error',
  couldNotGeneratePreview: 'Could not generate image preview.',
  
  // Loading states
  checkingAuthentication: 'Checking authentication...',
  loadingProfile: 'Loading profile...',
  profileRefreshed: 'Profile Refreshed',
  profileDataRefreshed: 'Profile data has been refreshed.',
  refreshError: 'Refresh Error',
  couldNotRefreshProfile: 'Could not refresh profile data.',
  refresh: 'Refresh',
  tryAgain: 'Try Again',
};
